import React, { useMemo } from 'react';
import { useStore } from 'effector-react';
import { products$ } from 'models/product';

import SliderWithMobileOverflowWrapper from 'features/SliderWithMobileOverflowWrapper';

import { T8y } from 'ui';

import style from './similarProducts.module.scss';

export const SimilarProducts = ({ currentProductId }) => {
  const products = useStore(products$);

  const similarProducts = useMemo(
    () => products.filter((el) => el.id !== currentProductId),
    [currentProductId, products],
  );

  return (
    <div className={style.similarProducts}>
      <T8y variant="h1v1" fullWidth mb2 className={style.similarProductsTitle}>
        Similar Products
      </T8y>
      <SliderWithMobileOverflowWrapper products={similarProducts} />
    </div>
  );
};
